import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useExamNavLock } from '../contexts/ExamContext';
import { useTranslation } from 'react-i18next';
import { usePendingSummary } from '../hooks/usePendingSummary';
import { IS_APP_BUILD } from '../lib/buildTarget';
// tutor-1 (D): sale de la barra el renglon Upgrade, y con el su etiqueta de referidos (sigue en el menu lateral).
// tutor-1 (C): el destino Tutor solo con el tutor de la sesion encendido.
import { useTutorDeLaSesion, tutorVisible } from '../lib/tutorDeLaSesion';
import { hapticImpactLight, __resetHapticsForTests } from '../lib/haptics';
import { log as diagLog } from '../lib/diag/readyChainLog';
import { logNavLoc } from '../lib/diag/navLoc';
import { NAV_ROW_HEIGHT_CLASS, PILL_BOTTOM_CLASS, PILL_BOTTOM_TABLET_CLASS } from '../lib/bottomNavMetrics';
import { esClickProgramatico, puente } from '../lib/carrilEstado';
import { clickProgramatico } from '../lib/useTabSwipe';
import { Menu, LayoutDashboard, BookOpen, BarChart3, Sparkles } from 'lucide-react';

/* T2 — LA PÍLDORA FLOTANTE (SÓLO app). Leer antes de tocar medidas.

   La web NO cambia: cada rama gateada por IS_APP_BUILD deja intacta la cadena
   de clases y la estructura de hoy (barra pegada de borde a borde, 6 tabs,
   cero listeners). IS_APP_BUILD es un corte de RUNTIME, no eliminación de
   código: los dos bundles cargan las dos ramas (ver lib/buildTarget.js).

   GEOMETRÍA: ya no vive aquí. El alto del nav es UN número en
   lib/bottomNavMetrics.js, y de ahí lo leen también la barra de acción de las
   sesiones, el colchón del área de contenido, el de los modales y el de las
   listas del Panel. Ese archivo explica de dónde sale cada medida; lo único
   que este componente decide es cómo se ve la cápsula.

   EL VIDRIO (post-smoke de Carlos: "se ve como bloque opaco"). La causa era la
   opacidad, no el blur: a 80% de fondo no hay desenfoque que se note sobre una
   funda oscura, porque casi nada la atraviesa. Fue bajando smoke a smoke —80,
   45, 30— hasta el 20% de hoy, con el blur y la saturación intactos: es la
   saturación la que hace que el vidrio se lea como vidrio y no como niebla
   gris. A este alfa el desenfoque manda sobre el tinte, que es el efecto que
   Carlos pidió; para que se note hace falta que haya contenido pasando por
   debajo, y de eso se encarga el alto a sangre del Panel.

   Tailwind emite `backdrop-filter` con su
   prefijo -webkit- (verificado en el CSS del build de app), que es lo que
   WKWebView exige. `overflow-hidden` se quitó a propósito: no hay nada que
   recortar en la app (el badge de pendientes vive en el nav de la web) y en
   iOS un `overflow:hidden` sobre un elemento con backdrop-filter y esquinas
   redondas es fuente conocida de rarezas de pintado.

   SIN SELECCIÓN AZUL. Los labels de los tabs son texto, y en iOS un toque
   sostenido sobre texto levanta la selección, la lupa y el menú de copiar —
   encima de un nav, donde el gesto natural es tocar y arrastrar el pulgar. La
   clase de la casa (`.app-noselect-text`, index.css) va en el contenedor de la
   píldora y se hereda a los cinco destinos, sus íconos y sus labels. Apaga
   selección de TEXTO, no eventos de puntero: la navegación por tap y el
   bloqueo durante una sesión siguen exactamente igual, y hay tests que lo
   fijan porque es el par que se puede romper junto.

   SIN CALLOUT NI ARRASTRE DE LIGA (S-7). Los destinos son anclas de verdad, y
   sobre un ancla iOS levanta su callout —la vista previa de la liga, con la URL
   interna `capacitor://localhost/...` a la vista— y deja arrastrarla. Lo apaga
   `.nav-no-callout` (index.css) puesta en los ÍTEMS, no en el chasis, más
   `draggable={false}` en las anclas. Va en los dos builds. No hay listeners de
   `contextmenu` ni de `dragstart`: el CSS es el mecanismo, y si el smoke en el
   iPhone demuestra que no basta, la intercepción iría en estos nodos y nunca en
   `document`.

   LO QUE JSDOM NO PUEDE JURAR (lo firma el smoke en el iPhone): que el vidrio
   se vea bien, que los márgenes queden parejos, que el teclado real dispare
   visualViewport, que el dedo acierte y que iOS respete el callout apagado.
   Los tests aseveran clases y cableado. */

// tutor-1 (D, #665 y firmas 7 y 8): LA MISMA PILDORA EN LAS DOS CASAS, y tambien en la tablet (768 a 1023): ahi va
// centrada, de 520 como maximo, a 16 del borde de abajo mas la zona segura. Desde 1024 no hay barra de abajo.
const PILL_SHELL_CLASS = [
  'lg:hidden fixed left-4 right-4 md:left-1/2 md:right-auto md:-translate-x-1/2 md:w-[min(520px,calc(100%-32px))] z-50',
  PILL_BOTTOM_CLASS,
  PILL_BOTTOM_TABLET_CLASS,
  // Cápsula + liquid glass, con la paleta que ya existe (#0e0e0e funda,
  // #262626 borde). Cero colores nuevos: sólo baja el alfa del fondo.
  'rounded-full border border-[#262626] bg-[#0e0e0e]/20',
  'backdrop-blur-2xl backdrop-saturate-150',
  'shadow-[0_10px_30px_rgba(0,0,0,0.55)]',
  'transition-[opacity,transform] duration-200 ease-out',
  // Sólo vive en esta cadena, que es la rama de app: la web nunca la escribe.
  'app-noselect-text',
].join(' ');

// T2-C3 — cuánto tiene que encoger el viewport visual para llamarle teclado.
// Los teclados de iPhone miden 250-340px; los ajustes de barra del navegador
// mueven 50-80px. 120px cae en medio y no confunde uno con el otro.
const KEYBOARD_MIN_INSET_PX = 120;

/* T2-C3 — la píldora se esconde con el teclado (SÓLO app).

   MECANISMO Y POR QUÉ: @capacitor/keyboard NO está instalado (package.json
   trae @capacitor/core, /ios, /cli, @capacitor-community/sqlite y
   @aparajita/capacitor-secure-storage — ninguno emite eventos de teclado), y
   esta tanda no instala dependencias. Se usa visualViewport, que es la señal
   que el WKWebView sí da sin plugin: al abrir el teclado el viewport VISUAL
   encoge contra el de LAYOUT. `offsetTop` entra en la resta porque iOS además
   desplaza el viewport visual cuando el campo enfocado queda bajo el teclado.

   El corte de build va ANTES de suscribir: en web este hook no registra ni un
   listener y devuelve false para siempre. */
function useKeyboardOpen() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    // tutor-1 (D): la pildora vive en las dos casas, asi que el teclado la esconde en las dos (mismo umbral).
    const vv = typeof window !== 'undefined' ? window.visualViewport : null;
    if (!vv) return undefined;
    const read = () => {
      const inset = window.innerHeight - vv.height - vv.offsetTop;
      setOpen(inset > KEYBOARD_MIN_INSET_PX);
    };
    read();
    vv.addEventListener('resize', read);
    vv.addEventListener('scroll', read);
    return () => {
      vv.removeEventListener('resize', read);
      vv.removeEventListener('scroll', read);
    };
  }, []);
  return open;
}

/* ── P-3 / MEJ-2 — DESLIZAR POR LA PÍLDORA ────────────────────────────────────

   QUÉ ES. Con el dedo sobre la píldora, un desplazamiento HORIZONTAL que pase
   el umbral entra en modo arrastre: el ícono bajo el dedo se resalta EN VIVO
   —el mismo naranja del tab activo, como CANDIDATO— y la navegación ocurre al
   SOLTAR, jamás durante el recorrido (G-F1). Soltar fuera de la píldora cancela
   sin navegar y devuelve el resalte al tab activo real (G-F3); soltar sobre
   "More" abre su cajón, igual que un tap (G-F4).

   LAS CUATRO REGLAS DURAS:

   · EL TAP NO SE TOCA. Por debajo del umbral no pasa NADA: el click natural del
     ancla navega como siempre, por el mismo camino de siempre. El único momento
     en que este código interviene sobre un click es cuando SÍ hubo arrastre, y
     es para suprimirlo.

   · CERO TIMERS. La distinción tap/arrastre es SOLO distancia. Dejar el dedo
     quieto y luego deslizar es un arrastre que empezó lento, no un
     press-and-hold: no hay un solo temporizador en todo el gesto.

   · CERO preventDefault SOBRE EL TOUCH, y no es pereza. React registra
     touchstart/touchmove en PASIVO sobre el contenedor raíz, así que un
     preventDefault ahí no haría nada (y la consola lo gritaría). Quien gobierna
     el scroll es `touch-action: pan-y` en la fila: el navegador se queda el
     desplazamiento vertical —la página sigue scrolleando aunque el dedo empiece
     sobre el nav— y nos deja el horizontal, que es exactamente el reparto que
     este gesto necesita. Va como ESTILO EN LÍNEA a propósito: las cadenas de
     clases del chasis, de la fila y de cada ítem se comparan carácter por
     carácter en las suites de web y de app, y una clase más ahí las rompería
     sin cambiar una coma del comportamiento.

   · CERO LISTENERS EN `document` (doctrina S-7). Todo cuelga de la fila por
     props de React, que delega en el contenedor RAÍZ — nunca en `document`. El
     espía de MobileBottomNav.calloutArrastre.test.js lo vigila.

   NAVEGAR = EL MISMO TAP. Al soltar sobre un destino se dispara un `click()`
   sobre ESE nodo: el mismo camino que el dedo ya recorría (el `Link` de
   react-router, o el botón oscurecido que levanta el toast durante una sesión).
   No hay una segunda ruta de navegación en este archivo, y por eso soltar con
   el candado de sesión puesto hace exactamente lo que hace un tap con el
   candado puesto. Durante ese candado tampoco hay resalte de candidato: los
   destinos bloqueados no se ofrecen como elegibles, y su cadena de clases queda
   byte-intacta.

   VIVE EN LOS DOS BUILDS. El gesto es táctil, así que la web de ESCRITORIO no
   cambia un render (ni un handler de mouse, ni una clase); la web MÓVIL sí lo
   estrena, que es lo correcto para una barra que ya se toca con el pulgar. La
   háptica es lo único app-only (ver el tic más abajo).

   LO QUE JSDOM NO PUEDE JURAR: que el arrastre se sienta suave, que el dedo le
   atine al ícono que cree y el tic háptico. Eso lo firma el smoke en el
   iPhone. */

// Umbral de arrastre. 12px es el mismo orden que el "slop" con el que los
// navegadores deciden si un toque que se movió todavía cuenta como click: por
// debajo de eso, lo que el usuario hizo fue un tap con pulso.
const PILL_DRAG_THRESHOLD_PX = 12;

// El reparto del scroll, en una propiedad. Constante de módulo para que el
// objeto no cambie de identidad entre renders.
const PILL_ROW_TOUCH_STYLE = { touchAction: 'pan-y' };

/* RECULE, UNA LÍNEA. Apagada, la fila se monta sin estilo, sin handlers y sin
   un solo prop nuevo: el tap puro de hoy, bit a bit. La dependencia de haptics
   puede quedarse instalada e inerte — sin este `true` no se importa nunca,
   porque el único que la llama es el arrastre. */
export const PILL_GESTURES = true;

// Espejo SOLO para tests (hermano de __setNetworkNativeSeedForTests en
// offline/networkVerdict.js): permite fijar el estado APAGADO sin tocar la
// constante de arriba, que es la que Carlos apaga de verdad. null = manda ella.
let pillGesturesOverrideForTests = null;
export function __setPillGesturesForTests(value) {
  pillGesturesOverrideForTests = value;
}
function pillGesturesEnabled() {
  return pillGesturesOverrideForTests === null ? PILL_GESTURES : pillGesturesOverrideForTests;
}

/* ── G-F2 — EL TIC HÁPTICO AL CRUZAR DE ÍCONO (SÓLO nativo) ───────────────────

   QUÉ SE SIENTE Y CUÁNDO. Durante el arrastre, y SÓLO al cruzar de un ícono a
   otro, un impacto ligero. Nada al soltar —la navegación es su propio feedback,
   y un tic ahí sería ruido justo cuando la pantalla ya cambió— y nada en un tap
   normal, que no cruza nada.

   PRIMERA DEPENDENCIA HÁPTICA DEL PROYECTO: `@capacitor/haptics`, el oficial,
   declarado como los otros plugins nativos del repo (una línea en package.json
   con versión EXACTA; el proyecto ios/ no vive aquí, lo genera Codemagic con
   `cap add ios` + `cap sync ios`, que registran los plugins solos).

   EL MECANISMO YA NO VIVE AQUÍ (COS-I). Se mudó ENTERO —gate app-only + shell
   nativo por llamada, import dinámico cacheado y fire-and-forget a prueba de
   todo— a `lib/haptics.js`, sin cambiar una coma, porque el swipe entre
   pestañas necesita EXACTAMENTE este tic y la doctrina del repo es cero copias.
   Este archivo conserva el nombre local y el punto de llamada: lo que decide
   CUÁNDO vibra la píldora (sólo al cruzar de ícono) sigue siendo suyo. */
const hapticCrossTick = hapticImpactLight;

/** Sólo para tests: devuelve el cacheo del módulo a su estado de arranque.
 *  Se re-exporta desde su nueva casa para que el arnés de G-F2 no se mueva. */
export { __resetHapticsForTests };

// tutor-2 (B.2): la pagina del Tutor y la tarjeta de a media sesion leen el MISMO detector del teclado (sin cambiarlo).
export { useKeyboardOpen };

/* ── COS-28 — EL ÍCONO CRECE MIENTRAS EL DEDO LO TIENE PICADO (SÓLO app) ──────

   QUÉ ES. El feedback de presión de la barra de Instagram: al mantener
   presionado un destino, éste escala un pelo y vuelve a su tamaño al soltar. Es
   ANIMACIÓN, nada más — no navega, no arma un gesto y no prepara ninguno.

   POR QUÉ CON TOUCH Y NO CON `:active` A SECAS. En WKWebView el `:active` de
   CSS es notoriamente caprichoso sobre elementos que no tienen manejadores de
   toque propios (el truco conocido para "despertarlo" es un listener de
   touchstart, y la doctrina S-7 prohíbe colgarlo de `document`). Con
   touchstart/touchend/touchcancel EN EL PROPIO ÍTEM el estado es explícito y
   determinista, y además es lo único que jsdom puede aseverar.

   POR QUÉ NO CUELGA DEL GESTO DE LA PÍLDORA. El arrastre (P-3) tiene su propio
   recule (`PILL_GESTURES`); si la animación colgara de ahí, apagar el gesto se
   llevaría también el feedback de presión, que es una cosa distinta. Son dos
   mecanismos independientes que conviven sobre el mismo dedo: los handlers del
   ítem burbujean hasta la fila sin cancelar nada, y la única palabra que se
   dicen es que al ENTRAR en modo arrastre la presión se apaga (si no, el ícono
   de salida se quedaría inflado mientras el dedo pasea por los otros).

   LO QUE NO TOCA: el tap navega por el mismo camino de siempre (ni un
   preventDefault, ni un stopPropagation), la selección de texto y el callout
   siguen apagados por sus clases de S-7, y la web no estrena ni una clase —el
   corte es `IS_APP_BUILD`, y ahí la píldora ni existe.

   LO QUE JSDOM NO PUEDE JURAR: que la escala se sienta bien y que el dedo
   perciba el rebote. Eso lo firma el smoke en el iPhone; el número está en una
   sola clase. */
const PILL_PRESS_SCALE_CLASS = 'scale-[1.08]';

/* ── REMATE-266 — LA AUTOPSIA DEL EMBUDO (`NAV.TAP`) ──────────────────────────

   Hasta hoy esta barra NO escribía una sola línea al visor, y ése era el hueco
   más caro del recon: el swipe del carril sí deja su `NAV.TABSWIPE`, pero el
   embudo por donde pasan TODOS los cambios de pestaña —el click sobre el
   destino de esta fila— era mudo. Con la barra muda, "vibró y no cambió" no
   tenía autopsia posible.

   Los seis campos son los seis estados que pueden matar un click aquí:
     destino       la ruta del nodo elegido ('/study'), 'more' para el cajón, o
                   null si no hubo nodo.
     huboArrastre  ¿el toque cruzó el umbral y entró en modo arrastre?
     idxHitTest    el índice bajo el dedo AL SOLTAR. `null` = el dedo salió de la
                   cápsula (la regla G-F3 de siempre; ver P4 abajo para qué pasa
                   ahora en ese caso).
     suppressClick el estado de la bandera de supresión en ese instante.
     ownClick      ¿el click lo disparó ESTE gesto?
     tragado       ¿el capture se lo comió? Sólo puede ser true en la línea que
                   escribe el propio capture.

   CÓMO SE LEE: `idxHitTest:null` es H1-a (soltó fuera). `tragado:true` con
   `ownClick:false` es H1-b (la bandera pegada se comió un click ajeno). */
function logNavTap(campos) {
  if (!IS_APP_BUILD) return;
  try { diagLog('NAV.TAP', campos); } catch (e) { /* el visor jamás decide un tap */ }
}

/* ¿Este click lo sintetizó EL NAVEGADOR como sombra de un toque, o lo disparó
   CÓDIGO? La frontera de P2 (ver el capture, más abajo). `isTrusted` es la que
   manda en el aparato; `detail > 0` es su gemela observable en jsdom, donde todo
   evento nace untrusted: un click de usuario trae contador de clicks ≥ 1 y
   `elemento.click()` trae 0, por el algoritmo de "synthetic pointer event" del
   estándar. Sin poder juzgar, se conserva el comportamiento anterior (tragar). */
function esSombraDelNavegador(e) {
  try {
    if (e.isTrusted === true) return true;
    return typeof e.detail === 'number' && e.detail > 0;
  } catch (err) {
    return true;
  }
}

/** El nodo de destino que corresponde a un evento de click dentro de la fila. */
function nodoDestinoDelEvento(e) {
  try {
    const t = e && e.target;
    return (t && t.closest && t.closest('[data-nav-to],[data-testid="bottom-nav-more"]')) || null;
  } catch (err) {
    return null;
  }
}

/** La ruta de un nodo de la fila, tal como el gesto y el swipe la nombran. */
function destinoDe(nodo) {
  try {
    if (!nodo) return null;
    const propio = nodo.getAttribute && nodo.getAttribute('data-nav-to');
    if (propio) return propio;
    const testid = nodo.getAttribute && nodo.getAttribute('data-testid');
    return testid === 'bottom-nav-more' ? 'more' : null;
  } catch (e) {
    return null;
  }
}

export default function MobileBottomNav() {
  const location = useLocation();
  const path = location.pathname;
  const { user } = useAuth();
  const { t } = useTranslation('common');

  // tutor-1 (D): aqui vivia el estado de referidos de la etiqueta del renglon Upgrade, que salio de la barra.
  // Pending badge: number of pending GROUPS (same count as the sidebar badge).
  const { groupCount } = usePendingSummary();
  // Mid-session lock — same source of truth and same darkened treatment as the
  // sidebar (see useExamNavLock in ExamContext). The "More" button stays live:
  // the drawer it opens locks its own items with the same state.
  const { isExamActive, blockNavigation } = useExamNavLock();
  const keyboardOpen = useKeyboardOpen();
  /* P-1 — el badge de pendientes en el ícono de "More" (SÓLO app).

     En la app Pendientes ya no es un destino del nav: vive dentro del drawer
     que abre "More" (T2-C2), y por eso el aviso tiene que estar en "More". En
     la WEB no: allí Pendientes sigue siendo su propio tab CON su badge, y
     pintar otro aquí sería el mismo número dos veces en la misma barra.

     Misma fuente y mismo instante que el badge del renglón del sidebar
     (usePendingSummary → groupCount): cero lógica nueva de conteo, cero fetch
     nuevo. Lo que ese hook devuelva hoy sin señal se respeta tal cual — su
     honestidad es asunto de otra tanda, no de esta. */
  // tutor-1 (D): Pendientes sale de la barra de la web tambien (firma 7), asi que su aviso vive en Mas en las dos casas.
  const moreBadgeCount = groupCount;
  const tutorDeLaSesion = useTutorDeLaSesion();

  /* P-3 — EL ESTADO DEL GESTO. Todo lo que cambia mientras el dedo se mueve
     vive en refs (cero renders por pixel recorrido); lo único que sube a estado
     de React es el CANDIDATO, que es lo único que se pinta. */
  const rowRef = useRef(null);
  // { x0, y0, active, index, ultimo } mientras hay un dedo abajo; null el resto
  // del tiempo. `active` sólo se enciende al cruzar el umbral en horizontal.
  // `ultimo` (REMATE-266 / P4) es el ÚLTIMO índice que estuvo resaltado durante
  // el recorrido — que NO es `index`, porque `index` se va a null en cuanto el
  // dedo sale de la cápsula y es justo ahí donde hace falta recordarlo.
  const dragRef = useRef(null);
  /* El `pathname` que React está pintando AHORA, legible desde handlers que se
     registran una vez. Lo necesita `NAV.LOC` para su segunda muestra: el eco
     tiene que comparar `window.location` contra lo que React pinta en ese
     momento, no contra lo que pintaba al soltar el dedo. */
  const pathRef = useRef(path);
  pathRef.current = path;
  // ¿El próximo click es la sombra de un arrastre y hay que tragárselo?
  const suppressClickRef = useRef(false);
  // ¿El click que está pasando lo disparó ESTE gesto? Ése sí pasa.
  const ownClickRef = useRef(false);
  const [dragCandidate, setDragCandidate] = useState(null);
  // COS-28 — qué ítem tiene el dedo encima AHORA MISMO (índice de la fila; el
  // botón "More" es el último). null = ninguno, que es el estado en web siempre.
  const [pressedIndex, setPressedIndex] = useState(null);
  const pressProps = useCallback((i) => (IS_APP_BUILD ? {
    onTouchStart: () => setPressedIndex(i),
    onTouchEnd: () => setPressedIndex(null),
    // El sistema se llevó el toque (llamada entrante, gesto de sistema): el
    // ícono no puede quedarse inflado para siempre.
    onTouchCancel: () => setPressedIndex(null),
  } : null), []);
  const pressClass = (i) => (pressedIndex === i ? ` ${PILL_PRESS_SCALE_CLASS}` : '');

  /* COS-I — LA MANIJA DEL SWIPE ENTRE PESTAÑAS (SÓLO app).

     El swipe horizontal sobre el contenido (lib/useTabSwipe.js) NO navega por su
     cuenta: al soltar dispara un `click()` sobre el DESTINO DE ESTA FILA, que es
     el mismo camino que el dedo recorre al tocarlo — y el mismo que ya usa el
     arrastre por la píldora (`finDelGesto`, más abajo). Para encontrar ese nodo
     necesita una manija estable, y el `data-testid` no sirve: se arma con la
     ETIQUETA TRADUCIDA (`bottom-nav-inicio` en español, `bottom-nav-home` en
     inglés), así que buscar por él ataría el gesto al idioma.

     Va en las DOS caras del destino —el ancla viva y el botón oscurecido de una
     sesión en curso— justamente para que el gesto herede los efectos de cada
     una: con el candado puesto, soltar hace lo mismo que un tap, el toast de
     "termina tu examen". "More" NO la lleva: es un cajón, no una pestaña, y por
     eso jamás puede ser destino de un swipe.

     APP-ONLY: en web el atributo ni se emite y el DOM de la barra queda
     byte-idéntico al de hoy. */
  // tutor-1 (D): la manija viaja en las dos casas (el gesto de arrastre de la pildora la usa tambien en la web).
  const navToProp = (to) => ({ 'data-nav-to': to });

  /* ── TANDA 17 (#202) — EL TAP TAMBIÉN ENTRA A LA COLA DE UNO ───────────────

     LA ASIMETRÍA QUE ESTO CIERRA. La cola de uno (#183, en `lib/useTabSwipe.js`)
     existe porque un aterrizaje EN VUELO —ya aterrizado en lo visual, React
     todavía sin confirmar— no admite una segunda navegación encima: los commits
     encimados son la mitad de la ráfaga que midió la bitácora del build 87. El
     swipe la respeta desde entonces; el tap directo no, porque el `<Link>`
     navegaba en el acto. La misma app tenía dos reglas para el mismo destino
     según cómo se llegara a él.

     LAS CUATRO PUERTAS, EN ORDEN, y las tres primeras dejan el tap intacto:
       1. Un click que disparó CÓDIGO —el desenlace del swipe, o la liberación de
          la propia cola— ya pasó por ella. Volver a encolarlo sería una fila
          infinita de un solo tap.
       2. Con modificadores o con un botón que no sea el principal manda el
          navegador: abrir en pestaña nueva es suyo, no nuestro.
       3. Sin puente (la web, o el carril desmontado) o sin vuelo, esto no existe:
          el `<Link>` navega como siempre. Es el 99% de los taps de la app.
       4. Y sólo entonces se encola. El `preventDefault` va DESPUÉS de que la cola
          confirme que lo tomó: frenar un click a cambio de nada sería tragarse el
          tap, que es peor que la asimetría que se está arreglando.

     Al tocarle su turno sale por `clickProgramatico` sobre ESE MISMO nodo, o sea
     por el tramo final idéntico al del swipe. `currentTarget` se lee aquí, en el
     vuelo del evento, porque React lo limpia al terminar la propagación. */
  const alTocarPestana = useCallback((e) => {
    if (esClickProgramatico()) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof e.button === 'number' && e.button !== 0) return;
    const p = puente();
    if (!p || !p.hayVuelo()) return;
    const nodo = e.currentTarget;
    if (!p.encolar(() => clickProgramatico(nodo))) return;
    e.preventDefault();
  }, []);
  const navClickProp = () => (IS_APP_BUILD ? { onClick: alTocarPestana } : null);

  /* Hit-test por rectángulos de los hijos de la fila. Con `flex-1` los ítems
     embaldosan la fila entera y no dejan huecos, así que "fuera de todos los
     rectángulos" es literalmente fuera de la píldora — que es la cancelación de
     G-F3. Se mide en el momento, no al montar: la píldora se mueve (teclado) y
     el aparato rota. */
  const hitTestIndex = useCallback((x, y) => {
    const row = rowRef.current;
    if (!row) return null;
    const nodes = row.children;
    for (let i = 0; i < nodes.length; i += 1) {
      const r = nodes[i].getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return i;
    }
    return null;
  }, []);

  const handleTouchStart = useCallback((e) => {
    const t = e.touches && e.touches[0];
    if (!t) return;
    // Un toque nuevo empieza limpio: ni arrastre, ni click pendiente de tragar.
    dragRef.current = { x0: t.clientX, y0: t.clientY, active: false, index: null, ultimo: null };
    suppressClickRef.current = false;
  }, []);

  const handleTouchMove = useCallback((e) => {
    const st = dragRef.current;
    const t = e.touches && e.touches[0];
    if (!st || !t) return;
    const dx = t.clientX - st.x0;
    const dy = t.clientY - st.y0;
    if (!st.active) {
      // Vertical dominante = scroll de la página, y aquí no pasa nada: ni
      // resalte, ni supresión, ni preventDefault. El umbral se mide contra el
      // ORIGEN del toque, no contra el último punto, para que un temblor no
      // sume distancia falsa.
      if (Math.abs(dx) <= Math.abs(dy) || Math.abs(dx) <= PILL_DRAG_THRESHOLD_PX) return;
      st.active = true;
      // Hubo arrastre: el click de compatibilidad que el navegador pueda mandar
      // al soltar ya no representa lo que el usuario quiso.
      suppressClickRef.current = true;
      // COS-28: esto ya no es una presión, es un recorrido. Quien manda el
      // resalte de aquí en adelante es el CANDIDATO, y el ícono de salida no
      // puede quedarse inflado mientras el dedo pasea por los otros.
      setPressedIndex(null);
      /* EL ORIGEN ES DONDE EL DEDO SE APOYÓ, no donde iba cuando cruzó el
         umbral. Importa para el tic: un movimiento rápido puede entregar el
         primer `touchmove` ya sobre el ícono de al lado, y ése es un cruce de
         verdad que el usuario hizo. Y el candidato arranca ahí, que es lo que
         hace que arrastrar desde un destino NO activo lo resalte de inmediato. */
      st.index = hitTestIndex(st.x0, st.y0);
      if (st.index !== null) st.ultimo = st.index;
      setDragCandidate(st.index);
    }
    const idx = hitTestIndex(t.clientX, t.clientY);
    if (idx === st.index) return;
    /* G-F2 — el tic va SÓLO de un ícono a OTRO. Salirse de la píldora no vibra
       (fuera no hay ícono que cruzar) y volver a entrar tampoco: el resalte que
       reaparece ya lo cuenta a la vista. */
    if (idx !== null && st.index !== null) hapticCrossTick();
    st.index = idx;
    // P4: el último resaltado se recuerda aunque el dedo se salga después. Es lo
    // ÚNICO que este `touchmove` estrena, y no cambia nada de lo de arriba.
    if (idx !== null) st.ultimo = idx;
    setDragCandidate(idx);
  }, [hitTestIndex]);

  /* El final del gesto, por los dos caminos que tiene (soltar y cancelación del
     sistema). `navegar` es lo único que los distingue.

     ── REMATE-266 / P4 — SOLTAR FUERA DE LA CÁPSULA YA NO TIRA EL GESTO ───────
     La regla G-F3 decía: soltar fuera cancela, cero navegación. Es defendible en
     un escritorio y es MALA en la calle. La cápsula mide 58 px de alto; en un
     coche en movimiento, con el pulgar, salirse por arriba al levantar el dedo
     no es raro — es lo esperable. Y el usuario ya cruzó íconos, ya vio el
     resalte moverse y YA SINTIÓ LA VIBRACIÓN (el tic de G-F2 va al cruzar, no al
     soltar), así que lo que percibe es "vibró y no pasó nada". Ese fue uno de
     los dos defectos probados del incidente del 2026-08-16.

     LA REGLA NUEVA, y es una sola frase: si durante el arrastre HUBO un ícono
     resaltado, soltar fuera navega al ÚLTIMO resaltado; si nunca lo hubo, se
     cancela exactamente como antes. Lo que el dedo prometió, se cumple.

     ── Y LA BANDERA SE DESARMA EN TODAS LAS SALIDAS ──────────────────────────
     Cada `return` de abajo que NO dispara un click deja `suppressClickRef` en
     false. El caso que muerde es la cancelación del sistema (`touchcancel`, una
     llamada entrante): ahí el navegador NO manda click de compatibilidad, así
     que la bandera se quedaba armada indefinidamente esperando una sombra que
     no iba a llegar — y se comía el siguiente click ajeno. Ver el capture. */
  const finDelGesto = useCallback((x, y, navegar) => {
    const st = dragRef.current;
    dragRef.current = null;
    // Sin arrastre no hubo gesto: el click natural del ancla manda, byte-igual
    // a como mandaba antes de esta tanda.
    if (!st) return;   // no hubo toque nuestro: ni gesto, ni línea que escribir
    if (!st.active) {
      // El tap de siempre. Se apunta igual —`huboArrastre:false`— porque "el tap
      // no hizo nada" es justo una de las cosas que el registro no sabía decir.
      const i = x === null ? null : hitTestIndex(x, y);
      logNavTap({
        destino: destinoDe(i === null ? null : (rowRef.current && rowRef.current.children[i])),
        huboArrastre: false, idxHitTest: i,
        suppressClick: suppressClickRef.current, ownClick: false, tragado: false,
      });
      return;
    }
    setDragCandidate(null);
    const idxHitTest = navegar ? (x === null ? st.index : hitTestIndex(x, y)) : null;
    // P4: fuera de la cápsula manda el último resaltado. `null` sólo sobrevive
    // si el arrastre jamás resaltó nada, y entonces sí se cancela como antes.
    const idx = navegar ? (idxHitTest === null ? st.ultimo : idxHitTest) : null;
    const nodo = idx === null ? null : (rowRef.current && rowRef.current.children[idx]);
    const autopsia = {
      destino: destinoDe(nodo), huboArrastre: true, idxHitTest,
      suppressClick: suppressClickRef.current, ownClick: false, tragado: false,
    };
    if (!nodo) {
      // Cancelación del sistema, o un arrastre que nunca resaltó nada: no hay
      // click que disparar y por lo tanto no hay sombra que tragar.
      suppressClickRef.current = false;
      logNavTap(autopsia);
      return;
    }
    logNavTap(autopsia);
    // G-F1 y G-F4: la navegación ocurre AQUÍ, una sola vez, y es EL MISMO tap —
    // el ancla del destino o el botón que abre el cajón, tal cual el dedo los
    // habría tocado.
    ownClickRef.current = true;
    try {
      nodo.click();
    } finally {
      ownClickRef.current = false;
    }
  }, [hitTestIndex]);

  const handleTouchEnd = useCallback((e) => {
    const t = e.changedTouches && e.changedTouches[0];
    finDelGesto(t ? t.clientX : null, t ? t.clientY : null, true);
  }, [finDelGesto]);

  // El sistema se llevó el toque (llamada entrante, gesto de sistema): eso NO
  // es soltar sobre un destino, así que cancela como G-F3.
  const handleTouchCancel = useCallback(() => {
    finDelGesto(null, null, false);
  }, [finDelGesto]);

  /* ── REMATE-266 / P2 — LA BANDERA PEGADA (defecto H1-b, probado) ────────────

     EL BUG. `suppressClickRef` existe para tragarse UNA cosa: la SOMBRA de
     compatibilidad que el navegador sintetiza al final de un toque. Pero se
     armaba y nadie garantizaba que alguien la desarmara: en iOS y en Android un
     toque que se MOVIÓ no produce click de compatibilidad (el reconocedor de
     gestos no lo declara tap), así que después de cada arrastre la bandera se
     quedaba puesta hasta el próximo `touchstart` SOBRE LA BARRA.

     Y ahí es donde mordía: el usuario navegaba arrastrando el pulgar por la
     píldora (bandera armada), después hacía un SWIPE SOBRE EL CONTENIDO —que no
     toca la barra— y el swipe, al commitear, dispara su propio `click()` sobre
     este mismo destino. Ese click llegaba aquí con `ownClick:false` y la bandera
     en true → `preventDefault` + `stopPropagation`, y el `<Link>` nunca corría.
     Vibra, el carril se desliza, y a los ~820 ms se regresa solo.

     LA FRONTERA QUE FALTABA: sólo se traga un click DEL NAVEGADOR. Un click
     SINTÉTICO —el que dispara el swipe del carril, o este mismo gesto— no es la
     sombra de nada: es otro mecanismo navegando a propósito. Pasa entero, y de
     paso desarma la bandera, que es lo que la vuelve auto-limpiante.

     `e.isTrusted` es la frontera de verdad y la que manda en el aparato;
     `e.detail > 0` es su gemela observable en jsdom (donde TODO evento es
     untrusted): un click de usuario trae contador de clicks ≥ 1 y
     `elemento.click()` trae 0, por el propio algoritmo de "synthetic pointer
     event" del estándar. Con las dos, la regla se puede fijar en rojo sin
     mentirle al navegador.

     LO QUE NO CAMBIA: el click propio del gesto sigue pasando y sigue DEJANDO la
     bandera armada, porque su sombra —si el navegador la manda— llega DESPUÉS y
     hay que tragársela igual. Eso es lo que protege el caso de dos navegaciones
     seguidas, y tiene su rojo desde P-3. */
  const handleClickCapture = useCallback((e) => {
    if (ownClickRef.current) return;       // el click que este gesto acaba de disparar
    if (!suppressClickRef.current) return; // no hubo arrastre: el tap de siempre
    suppressClickRef.current = false;      // se desarma SIEMPRE que llega un click
    if (!esSombraDelNavegador(e)) return;  // click de código: no es una sombra, pasa
    logNavTap({
      destino: destinoDe(nodoDestinoDelEvento(e)),
      huboArrastre: true, idxHitTest: null,
      suppressClick: true, ownClick: false, tragado: true,
    });
    e.preventDefault();
    e.stopPropagation();
  }, []);

  /* NAV.LOC — la línea 1 del recon §4.2, y desde UN solo punto.
     Va en BURBUJA sobre la fila, o sea después del `onClick` del `<Link>`: para
     cuando corre, `navigate()` ya llamó a `pushState` y `window.location` ya se
     movió si el click llegó. Y cubre los TRES caminos de una vez, porque los
     tres terminan en un click sobre un hijo de esta fila: el tap directo, el
     arrastre por la píldora (`nodo.click()`) y el swipe del carril (que dispara
     `click()` sobre este mismo destino). Un click que el capture se tragó no
     llega hasta aquí — correcto: no navegó nada que medir. */
  const handleClick = useCallback((e) => {
    logNavLoc('pildora', () => pathRef.current, {
      destino: destinoDe(nodoDestinoDelEvento(e)),
      own: ownClickRef.current,
    });
  }, []);

  // Un solo lugar donde el recule se lee, y todo el gesto cuelga de él.
  const gestureProps = pillGesturesEnabled() ? {
    ref: rowRef,
    style: PILL_ROW_TOUCH_STYLE,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    onTouchCancel: handleTouchCancel,
    onClickCapture: handleClickCapture,
    onClick: handleClick,
  } : null;

  // tutor-1 (D, #665): LA MISMA LISTA PARA TODOS LOS PLANES Y PARA LAS DOS CASAS: Inicio, Estudiar, Analiticas,
  // Tutor (solo con el tutor de la sesion encendido; apagado, la barra queda en cuatro) y Mas. "Mejorar plan" y
  // "Pendientes" salen de la barra (siguen en el menu lateral, en Mas y en todos los caminos de compra).
  const tabs = [
    { to: '/dashboard', icon: LayoutDashboard, label: t('mobile_nav.home') },
    { to: '/study', icon: BookOpen, label: t('mobile_nav.study') },
    { to: '/analytics', icon: BarChart3, label: t('mobile_nav.analytics') },
    ...(tutorVisible(tutorDeLaSesion, user) ? [{ to: '/tutor', icon: Sparkles, label: t('mobile_nav.tutor'), key: 'tutor' }] : []),
  ];

  // tutor-1 (D): la barra plana de la web murio; la web toma la pildora de la app (y el teclado la esconde igual).
  const navClass = `${PILL_SHELL_CLASS} ${keyboardOpen ? 'opacity-0 translate-y-[200%] pointer-events-none' : 'opacity-100 translate-y-0'}`;
  // El alto sale de la fuente unica (lib/bottomNavMetrics).
  const rowClass = `flex items-center justify-around ${NAV_ROW_HEIGHT_CLASS}`;
  const iconClass = 'w-6 h-6';
  const labelClass = 'text-[11px] font-medium truncate max-w-full px-0.5';
  const tabBoxClass = 'flex flex-col items-center justify-center gap-1 flex-1 h-full';
  // S-7 — el apagado de callout/arrastre viaja con cada item, en los dos builds.
  const navItemClass = `${tabBoxClass} nav-no-callout`;
  /* COS-28 — la transición del ítem. En web es la `transition-colors` de
     siempre, carácter por carácter (la suite la compara entera). En app pasa a
     nombrar sus DOS propiedades: `transition-colors` sola escribiría
     `transition-property: color…` y se llevaría por delante la animación del
     `transform`, que es justo lo que esta tanda estrena. El par
     `transition-[a,b]` ya es del repo: la píldora lo usa para esconderse con el
     teclado (`transition-[opacity,transform]`, arriba). */
  const itemTransitionClass = IS_APP_BUILD
    ? 'transition-[color,transform] duration-150 ease-out'
    : 'transition-colors';

  return (
    <nav className={navClass} data-testid="mobile-bottom-nav">
      <div className={rowClass} {...(gestureProps || {})}>
        {tabs.map((tab, i) => {
          /* Durante un arrastre el resalte es del CANDIDATO —el ícono bajo el
             dedo—, no del tab activo real: es el mismo naranja, prestado. Sin
             arrastre (o con el dedo fuera de la píldora) manda la regla de
             siempre, carácter por carácter. */
          const isActive = dragCandidate === null
            ? (path === tab.to || (tab.to !== '/dashboard' && path.startsWith(tab.to)))
            : dragCandidate === i;
          const tabInner = (
            <>
              <span className="relative">
                <tab.icon className={iconClass} />
              </span>
              <span className={labelClass}>{tab.label}</span>
            </>
          );
          // Mid-session: tabs go dark (#333, the sidebar's locked tone) and tapping
          // shows the same "finish your exam" toast instead of navigating.
          if (isExamActive) {
            return (
              <button key={tab.to} onClick={blockNavigation}
                {...(navToProp(tab.to) || {})}
                className={`${navItemClass} text-[#333] cursor-not-allowed`}
                data-testid={`bottom-nav-${(tab.key || tab.label).toLowerCase()}`}>
                {tabInner}
              </button>
            );
          }
          // COS-28: la presión sólo se monta donde hay algo que presionar — el
          // destino vivo. El tab oscurecido de una sesión en curso no ofrece
          // afordancia y su cadena de clases queda byte-intacta, igual que con
          // el resalte del arrastre.
          // SPA navigation via react-router Link — matches the Sidebar's NavLink
          // pattern. The prior <a href> triggered a full document reload on every
          // tap, which in the Capacitor WebView rebooted the whole SPA; it also
          // cost a flash on the web. Classes, structure and the manual `isActive`
          // styling are preserved exactly.
          return (
            <Link key={tab.to} to={tab.to} draggable={false}
              {...(pressProps(i) || {})}
              {...(navToProp(tab.to) || {})}
              {...(navClickProp() || {})}
              className={`${navItemClass} ${itemTransitionClass} ${isActive ? 'text-[#FF6B00]' : 'text-[#6a6a6a]'}${pressClass(i)}`}
              data-testid={`bottom-nav-${(tab.key || tab.label).toLowerCase()}`}>
              {tabInner}
            </Link>
          );
        })}
        <button onClick={() => document.dispatchEvent(new CustomEvent('toggle-sidebar'))}
          {...(pressProps(tabs.length) || {})}
          // P-3: "More" también es un candidato válido del arrastre (G-F4), y
          // se resalta con el mismo naranja prestado. Sin arrastre la cadena es
          // la de siempre, byte por byte.
          className={`${navItemClass} ${dragCandidate === tabs.length ? 'text-[#FF6B00]' : 'text-[#6a6a6a]'} ${itemTransitionClass}${pressClass(tabs.length)}`}
          // El nombre accesible sólo cambia cuando HAY conteo: sin pendientes el
          // atributo ni se emite y el botón se sigue llamando por su texto.
          aria-label={moreBadgeCount > 0 ? `${t('mobile_nav.more')} (${t('mobile_nav.pending')}: ${moreBadgeCount})` : undefined}
          data-testid="bottom-nav-more">
          {/* tutor-1 (D): el envoltorio `relative` (el mismo patron que los otros destinos) con el aviso de
              Pendientes, en las dos casas: Pendientes ya no es destino de la barra en ninguna. */}
          {(
            <span className="relative">
              <Menu className={iconClass} />
              {moreBadgeCount > 0 && (
                /* Anclado a la esquina del ÍCONO y absoluto: no empuja
                   métricas, así que la fila, el tap target y las safe areas de
                   la píldora quedan intactos. Decorativo: el conteo lo dice el
                   aria-label de arriba, y `pointer-events-none` deja que el
                   dedo siempre le pegue al botón. Espeja al renglón del
                   sidebar (número, mismo naranja) con tope visual de dos
                   caracteres.

                   COS-29 — EL DÍGITO RESPIRA. Nacía con la caja justa del
                   número (14×14 con `px-1` y tipografía de 9px): en el teléfono
                   se leía apretado contra el borde, sobre todo con el "9+".
                   Sube a 18×18 con `px-1.5` y 10px de tipografía —EXACTAMENTE
                   las medidas del badge del renglón del sidebar
                   (Sidebar.js, `min-w-[18px]` / `text-[10px]`), que es el
                   hermano de este número—, así que no es un tamaño inventado
                   sino el que el repo ya usa para lo mismo. Sigue siendo
                   absoluto sobre el envoltorio del ícono: cero métricas de la
                   fila movidas, y el ancla horizontal (`-right-2.5`) no cambia.
                   El del renglón del sidebar se queda como está.

                   COS-29b — Y BAJA 2px (smoke-2 de Carlos: "el número quedó en
                   el mero borde"). Al crecer, el badge se comió su propio aire:
                   con 6px de sobresalida (`-top-1.5`) su borde de arriba caía a
                   menos de 1px del filo de la cápsula, que a esa altura ya va
                   curvándose hacia abajo. La sobresalida pasa a 4px (`-top-1`) y
                   la fila sube 4px en lib/bottomNavMetrics.js: la cuenta
                   completa, y el porqué de repartirlo entre las dos mitades en
                   vez de cargarle todo a una, está en ese archivo. Sigue siendo
                   el mismo ancla, 2px más adentro — ni el tamaño, ni el color,
                   ni el `-right-2.5` se mueven. */
                <span
                  className="absolute -top-1 -right-2.5 bg-[#FF6B00] text-white text-[10px] font-semibold rounded-full px-1.5 min-w-[18px] h-[18px] flex items-center justify-center pointer-events-none"
                  aria-hidden="true"
                  data-testid="bottom-nav-more-badge"
                >
                  {moreBadgeCount > 9 ? '9+' : moreBadgeCount}
                </span>
              )}
            </span>
          )}
          {/* COS-G B4 — el único tab que seguía en inglés con la app en español. Sus
              cuatro hermanos ya salen de `mobile_nav.*` (:451-460); éste era un literal.
              Sólo cambia la CADENA: la lógica del drawer y la del badge (COS-29) quedan
              intactas, y el aria-label de arriba usa la misma llave para que el nombre
              accesible no se quede a medio traducir. */}
          <span className="text-[11px] font-medium">{t('mobile_nav.more')}</span>
        </button>
      </div>
    </nav>
  );
}
